/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Copy_Id_TitleInputs */



/**
* | output |
* | --- |
* | "Copy ID to clipboard" |
*
* @param {Explorer_Info_Copy_Id_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_copy_id_title = /** @type {((inputs?: Explorer_Info_Copy_Id_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Copy_Id_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier l'ID dans le presse-papiers")
	if (locale === "de") return /** @type {LocalizedString} */ ("ID in die Zwischenablage kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia l'ID negli appunti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать ID в буфер обмена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar ID al portapapeles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制 ID 到剪贴板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("IDをクリップボードにコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आईडी को क्लिपबोर्ड पर कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar ID para a área de transferência")
	return /** @type {LocalizedString} */ ("Copy ID to clipboard")
});